<template>
  <div class="formgrid grid">
    <label class="field col-12 md:col-1 fieldLabel">Zone:</label>
    <Dropdown class="field col-12 md:col-3" v-model="selectedZone" :options="zones" optionLabel="name" :filter="true"
      @change='filterTasks(selectedZone);' style="height: 30px;" id="selectedZone">
    </Dropdown>
    <div class="field col-12 md:col-1" v-if="!readonly"></div>
    <label class="field col-12 md:col-2 fieldLabel" v-if="!readonly">Import from Zone:</label>
    <div class="field col-12 md:col-5" style="padding: 0" v-if="!readonly">
      <div class="formgrid grid">
        <Dropdown v-model="selectedZoneTemplate" :options="zones" optionLabel="name"
          style="height: 30px; width: calc(100% - 205px)" :filter="true">
        </Dropdown>
        <div style="width: 205px">
          <Button class="" :label="`Import from ${selectedZoneTemplate.name}`" icon="pi pi-download"
            @click="importTasks" style="float: right; width: 200px"></Button>
        </div>
      </div>
    </div>
    <label class="field col-12 md:col-1 fieldLabel" v-if="!readonly">New Activity:</label>
    <div class="field col-12 md:col-3" style="padding: 0">
      <AutoComplete style="padding: 0; height: 30px" v-model="newTask[0].group" :suggestions="filteredGroups"
        @complete="searchGroup($event)" :dropdown="true" placeholder="New construction work name (optional)"
        v-if="!readonly">
      </AutoComplete>
    </div>
    <div class="field col-12 md:col-3" v-if="!readonly">
      <div class="formgrid grid">
        <InputText style="height: 30px; margin: 0; width: calc(100% - 40px)" v-model="newTask[0].name"
          placeholder="New activity name"> </InputText>
        <Button icon="pi pi-list" class="field col-12 md:col-1" style="height: 30px; margin: 0; width: 30px"
          @click="openCWAct" aria-label="Add activities from construction works"
          v-tooltip="'Add activities from construction works'" />
      </div>
    </div>
    <div class="field col-12 md:col-5" style="padding: 0" v-if="!readonly">
      <div class="formgrid grid">
        <Calendar style="padding: 0; width: calc(100% - 205px)" v-model="newTaskDuration" showIcon="true"
          dateFormat="yy-mm-dd" selectionMode="range" placeholder="New activity duration" />
        <div style="width: 205px">
          <Button :label="'Add Activity'" icon="pi pi-plus" @click="addNewTask(newTask[0])"
            style="float: right; width: 200px"></Button>
        </div>
      </div>
    </div>
    <div v-if="readonly" class="field col-12 md:col-8"></div>
    <label class="field col-12 md:col-1 fieldLabel">Construction Work:</label>
    <MultiSelect class="field col-12 md:col-9" v-model="selectedGroups" :options="groups" optionLabel="name"
      placeholder="Filter by Construction Work" display="chip" @change="filterTasks()" style="height: 30px">
      <template #option="slotProps">
        <div :class="slotProps.option.custom_class" style="width: 100%; text-align: center">{{ slotProps.option.name }}
        </div>
      </template>
    </MultiSelect>
    <label class="field col-12 md:col-1 fieldLabel">Display Period:</label>
    <Dropdown class="field col-12 md:col-1" v-model="selectedMode" :options="modes" @change="
      this.gantt.change_view_mode(selectedMode);
    updateHeight();
    " style="height: 30px"></Dropdown>
  </div>
  <!-- <div class="formgrid grid">
            <span class="p-buttonset">
                    <Button v-for="item in group" :label="item.name"
                        :class="item.selected ? item.custom_class : 'deselected'"
                        @click='item.selected = !item.selected; filterTasks();' />
                </span>
            <label class="field col-12 md:col-1 fieldLabel">Construction Work:</label>
            <MultiSelect class="field col-12 md:col-9" v-model="selectedGroups" :options="groups" optionLabel="name"
                placeholder="Filter by Construction Work" display="chip" @change="filterTasks()" style="line-height: 20px;">
                <template #option="slotProps">
                    <div :class="slotProps.option.custom_class" style="width:100%;text-align: center;">{{
                            slotProps.option.name
                    }}</div>
                </template>
            </MultiSelect>
            <label class="field col-12 md:col-1 fieldLabel">Display Period:</label>
            <Dropdown class="field col-12 md:col-1" v-model="selectedMode" :options="modes"
                @change='this.gantt.change_view_mode(selectedMode); updateHeight()' style="line-height: 20px;"></Dropdown>
        </div> -->
  <div style="display: flex">
    <div v-if="!readonly" style="width: 100%" class="formgrid grid">
      <DataTable :value="taskFiltered" class="p-datatable-sm field col-12 md:col-5" :scrollable="true"
        scrollHeight="calc(100vh - 208px - 4rem - 268px - 43px - 80px)" id="targetHeight" editMode="cell"
        style="margin-top: 28px" @cell-edit-complete="onTaskEditComplete">
        <Column field="group" header="Construction Work (Optional)" style="min-width: 45%">
          <!-- <template #body="slotProps">
                            <label v-if="!newTask.includes(slotProps.data)">{{ slotProps.data.group }}</label>
                            <AutoComplete v-else v-model="slotProps.data.group" :suggestions="filteredGroups"
                                @complete="searchGroup($event)" :dropdown="true" style="width:100%"
                                placeholder="New construction work name">
                            </AutoComplete>
                        </template> -->
          <template #editor="{ data, field }">
            <AutoComplete v-model="data[field]" :suggestions="filteredGroups" @complete="searchGroup($event, data)"
              :dropdown="true" style="width: 100%" placeholder="New construction work name (optional)">
            </AutoComplete>
            <!-- <InputText type="text" v-model="data[field]" autofocus /> -->
          </template>
        </Column>
        <Column field="name" header="Activity" style="min-width: 45%">
          <template #body="slotProps">
            <label v-if="!newTask.includes(slotProps.data)">{{ slotProps.data.name }}</label>
            <div v-else class="formgrid grid" style="width: 100%">
              <InputText class="field col-12 md:col-9" v-model="slotProps.data.name" placeholder="New activity name"
                style="margin: 5px 0; height: 29px">
              </InputText>
              <Button icon="pi pi-list" aria-label="Add activities from construction works"
                class="field col-12 md:col-3" @click="openCWAct" style="margin: 5px"
                v-tooltip="'Add activities from construction works'" />
            </div>
          </template>
          <template #editor="{ data, field }">
            <InputText type="text" v-model="data[field]" autofocus />
          </template>
        </Column>
        <Column style="width: 5%">
          <template #header>
            <Button icon="pi pi-times" :icon="slotProps.data.deleting"
              class="p-button-rounded p-button-secondary p-button-text p-button-danger" @click="deleteTasksFromZone"
              aria-label="Delete All" v-tooltip="'Delete All'" style="height: 12px" />
          </template>
          <template #body="slotProps">
            <Button v-if="!newTask.includes(slotProps.data)" icon="pi pi-times" :icon="slotProps.data.deleting"
              class="p-button-rounded p-button-secondary p-button-text p-button-danger" aria-label="Delete"
              @click="deleteTaskFromZone(slotProps.data)" v-tooltip="'Delete'" />
            <Button v-else icon="pi pi-plus" class="p-button-rounded p-button-secondary p-button-text p-button-success"
              @click="addNewTask(slotProps.data)" v-tooltip="'Add'" :disabled="slotProps.data.name == ''" />
          </template>
        </Column>
      </DataTable>
      <div v-if="taskFiltered.length == 0">No tasks found.</div>
      <GanttChart v-if="taskFiltered.length > 0" :gantt="gantt" :groups="groups" :taskFiltered="taskFiltered"
        @setGantt="setGantt" @filterTasks="filterTasks" class="col-12 md:col-7" :readonly="false"
        :projectStart="projectStart" :projectEnd="projectEnd" />
    </div>
    <div v-else style="width: 100%" class="formgrid grid">
      <DataTable :value="taskFiltered" class="p-datatable-sm field col-12 md:col-5" :scrollable="true"
        scrollHeight="calc(100vh - 208px - 4rem - 268px - 50px - 43px - 80px)" id="targetHeight"
        style="margin-top: 28px">
        <Column field="group" header="Group" style="min-width: 50%"> </Column>
        <Column field="name" header="Task" style="min-width: 50%"> </Column>
      </DataTable>
      <div v-if="taskFiltered.length == 0">No tasks found.</div>
      <GanttChart v-if="taskFiltered.length > 0" :gantt="gantt" :groups="groups" :taskFiltered="taskFiltered"
        @setGantt="setGantt" @filterTasks="filterTasks" class="col-12 md:col-7" :readonly="true"
        :projectStart="projectStart" :projectEnd="projectEnd" />
    </div>
  </div>
</template>

<script>
import GanttChart from "./GanttChart.vue";
import { ref } from "vue";
import DateHelper from "@/helper/DateHelper";

export default {
  name: "TaskTable",
  components: {
    GanttChart,
  },
  props: {
    tasks: Array,
    taskFiltered: Array,
    zones: Array,
    groups: Array,
    constructionWorks: Array,
    activities: Array,
    gantt: Object,
    readonly: Boolean,
    projectStart: Date,
    projectEnd: Date,
    selectedZone: Object,
    projectId: Number,
  },
  data() {
    return {
      modes: ref(["Day", "Week", "Month", "Year"]),
      selectedMode: ref("Month"),
      selectedGroups: [],
      newTaskDuration: null,
      newTask: [
        {
          start: DateHelper.getDateString(new Date()),
          end: DateHelper.getDateString(new Date(new Date().getFullYear(), new Date().getMonth() + 1, new Date().getDate())),
          name: "",
          id: "",
          group: "",
          zone: "",
          cwModel: "",
          activityModel: "",
          cwOrActivityModel: "",
        },
      ],
      // selectedZone: this.zones[0],
      selectedZoneTemplate: this.zones[0],

      filteredGroups: null,
    };
  },
  mounted() {
    if (this.projectStart) {
      if ((DateHelper.getDate(this.projectEnd).getTime() - DateHelper.getDate(this.projectStart).getTime()) / (1000 * 3600 * 24) < 60) {
        this.selectedMode = "Day";
      } else if ((DateHelper.getDate(this.projectEnd).getTime() - DateHelper.getDate(this.projectStart).getTime()) / (1000 * 3600 * 24) > 365) {
        this.selectedMode = "Year";
      }
    }
  },
  methods: {
    updateSelectedZone(value) {
      this.$emit("update:selectedZone", value);
    },
    setGantt(gantt) {
      this.$emit("setGantt", gantt);
    },
    setSelectedGroups(group) {
      this.$emit("setSelectedGroups", group);
    },
    importTasks() {
      let props = this;
      let taskImported = [];
      let maxId = props.tasks.length == 0 ? 0 : Math.max(...props.tasks.map((t) => parseInt(t.id)));
      let targetTasks = this.tasks.filter((t) => t.zone == this.selectedZoneTemplate.id);
      if (targetTasks.length) {
        targetTasks.map((task) => {
          taskImported.push({
            ...task,
            zone: this.selectedZone.id,
            id_0: -1,
            id: `${maxId + taskImported.length + 1}`,
          });
        });
        const updatedTasks = [...this.tasks, ...taskImported];
        this.$emit("setTasks", updatedTasks);
        this.filterTasks();
      } else {
        alert(`No tasks in ${this.selectedZoneTemplate.name}`);
      }
    },
    filterTasks() {
      let selectedGroupNames = [...new Set(this.selectedGroups.map((item) => item.name))];
      this.$emit("setSelectedGroups", selectedGroupNames);
      this.$emit("setSelectedZone", this.selectedZone);
      this.$emit("filterTasks", this.selectedZone);
      this.updateHeight();
    },
    searchGroup(event, task) {
      let groupNames = [...new Set(this.groups.map((item) => item.name))];
      if (!event.query.trim().length) {
        this.filteredGroups = groupNames;
      } else {
        this.filteredGroups = groupNames.filter((group) => {
          return group.toLowerCase().startsWith(event.query.toLowerCase());
        });
      }
      // if (task) {
      //     let group = this.groups.filter(e => e.name === task.group)
      //     if (group.length == 0) {
      //         task.custom_class = `custom_class${this.groups.length + 1}`;
      //         this.groups.push({
      //             name: task.group,
      //             custom_class: `custom_class${this.groups.length + 1}`
      //         })
      //     }
      //     else {
      //         task.custom_class = group[0].custom_class;
      //     }
      //     console.log(this.groups);
      //     this.filterTasks();
      // }
    },
    addNewTask(task) {
      let props = this;
      let group = props.groups.filter((e) => e.name === task.group);
      if (group.length == 0) {
        props.groups.push({
          name: task.group,
          custom_class: `custom_class${props.groups.length + 1}`,
        });
      }
      task.zone = this.selectedZone.id;
      task.start = DateHelper.getDateString(this.newTaskDuration[0]);
      task.end = DateHelper.getDateString(this.newTaskDuration[1]);
      console.log("addTask addNewTask task", task);
      this.$emit("addTask", task);
      this.newTask = [
        {
          start: task.start,
          end: task.end,
          name: "",
          id: "",
          group: task.group,
          zone: "",
          cwModel: "",
          activityModel: "",
          cwOrActivityModel: "",
        },
      ];
    },
    deleteTaskFromZone(task) {
      let props = this;
      task.deleting = "pi pi-spin pi-spinner";
      console.log("deleteTaskFromZone props.tasks", props.tasks);
      const deleteTaskLocally = () => {
        let index = props.tasks.indexOf(task);
        if (index > -1) {
          // Create a new array without the task
          const updatedTasks = props.tasks.filter((item, i) => i !== index);
          props.$emit("setTasks", updatedTasks);
        }
      };
      if (task.id_0 && task.id_0 > -1) {
        this.axios
          .delete(`${this.apiEndpoint}task?id=${task.id_0}`)
          .then((response) => {
            deleteTaskLocally();
            this.axios
              .delete(`${this.apiEndpoint}projectpme/projectid/${props.projectId}/zoneid/${task.zone}/taskid/${task.id}`)
              .then((response) => { })
              .catch((error) => {
                console.error(error);
              });
          })
          .catch((error) => {
            console.error(error);
            deleteTaskLocally();
            this.axios
              .delete(`${this.apiEndpoint}projectpme/projectid/${props.projectId}/zoneid/${task.zone}/taskid/${task.id}`)
              .then((response) => { })
              .catch((error) => {
                console.log(error);
              });
          });
      } else {
        deleteTaskLocally();
      }
    },
    deleteTasksFromZone() {
      this.taskFiltered.forEach((t) => {
        this.deleteTaskFromZone(t);
      });
    },
    updateHeight() {
      var new_height = document.getElementById("targetHeight").children[0].children[0].offsetHeight;
      new_height = this.readonly ? new_height + 78 : new_height + 28;
      if (new_height > 0 && this.gantt) {
        this.gantt.$svg.setAttribute("height", new_height);
      }
    },
    openCWAct() {
      this.$emit("openCWAct");
    },
    onTaskEditComplete(event) {
      console.log("complete");
      let props = this;
      let { data, newValue, field } = event;
      switch (field) {
        case "group":
          let group = props.groups.filter((e) => e.name === newValue);
          if (group.length == 0) {
            data.custom_class = `custom_class${props.groups.length + 1}`;
            props.groups.push({
              name: newValue,
              custom_class: `custom_class${props.groups.length + 1}`,
            });
          } else {
            data.custom_class = group[0].custom_class;
          }
          data[field] = newValue;
          props.$emit("updateEquipmentGroup", data);
          break;

        default:
          if (newValue.trim().length > 0) data[field] = newValue;
          else event.preventDefault();
          break;
      }
      this.filterTasks();
    },
  },
};
</script>

<style scoped></style>
<style>
#targetHeight>div.p-datatable-wrapper>table>tbody.p-datatable-tbody.p-datatable-frozen-tbody {
  top: 29px !important;
}

#targetHeight>div.p-datatable-wrapper>table>tbody>tr {
  height: 49px;
  max-height: 49px;
}

/* Hide scrollbar for Chrome, Safari and Opera */
#targetHeight .p-datatable-wrapper::-webkit-scrollbar {
  display: none;
}

/* Hide scrollbar for IE, Edge and Firefox */
#targetHeight .p-datatable-wrapper {
  -ms-overflow-style: none;
  /* IE and Edge */
  scrollbar-width: none;
  /* Firefox */
}
</style>
